"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const SvgBoltOff = (props) => (React.createElement("span", { className: "anticon" },
    React.createElement("svg", Object.assign({ fill: "none", stroke: "currentColor", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", className: "PayPing-icon" }, props),
        React.createElement("path", { d: "m12.426 6.5689 0.61038-4.9138-2.5138 3.0207" }),
        React.createElement("path", { d: "m18.799 12.941 2.5138-3.0103h-5.5241" }),
        React.createElement("path", { d: "m7.8637 7.862-5.1724 6.2069h9.3103l-1.0345 8.2758 5.1724-6.2069" }),
        React.createElement("path", { d: "m0.62069 0.62069 22.759 22.759" }))));
exports.default = SvgBoltOff;
//# sourceMappingURL=BoltOff.js.map